import { createRouter, createWebHashHistory } from "vue-router";

import Home from "@/views/homePageView.vue";

import AboutCollegeView from "@/views/aboutCollegeView.vue";
import AchieversView from "@/views/achieversView.vue";
import AdmissionView from "@/views/admissionView.vue";
import ContactView from "@/views/contactView.vue";

import CoursesView from "@/views/coursesView.vue";
import DirectorMessageView from "@/views/directormessageView.vue";
import EligiblityView from "@/views/eligiblityView.vue";
import InfraView from "@/views/infraView.vue";
import MentorView from "@/views/mentorBoardView.vue";

import NotFound from "@/components/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/aboutcollege",
    name: "AboutCollege",
    component: AboutCollegeView,
  },
  {
    path: "/achievers",
    name: "Achievers",
    component: AchieversView,
  },
  {
    path: "/admission",
    name: "Admission",
    component: AdmissionView,
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
  },

  {
    path: "/courses",
    name: "Courses",
    component: CoursesView,
  },
  {
    path: "/directorMessage",
    name: "DirectorMessage",
    component: DirectorMessageView,
  },
  {
    path: "/eligiblity",
    name: "Eligiblity",
    component: EligiblityView,
  },
  {
    path: "/infra",
    name: "Infra",
    component: InfraView,
  },
  {
    path: "/mentor",
    name: "MentorView",
    component: MentorView,
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
  },

  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  history: createWebHashHistory(),
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
